import { ClipboardEventData, Plugin, DomEventData, EventInfo } from "ckeditor5";

//
// This plugin works around https://github.com/ckeditor/ckeditor5/issues/6312
// setData() on CKE5's DataTransfer object has no effect
//
export default class MutableClipboardData extends Plugin {
  init() {
    const viewDocument = this.editor.editing.view.document;

    for (const event of ["paste", "drop", "dragover"]) {
      this.listenTo(
        viewDocument,
        event,
        this.allowClipboardDataTransferSetData,
        {
          priority: "highest",
        },
      );
    }
  }

  allowClipboardDataTransferSetData(
    _e: EventInfo,
    eventData: DomEventData & ClipboardEventData,
  ) {
    const overrides = new Map<string, string>();
    const overrideTypes: string[] = [];

    const { getData: getDataInner, types: typesInner } = eventData.dataTransfer;

    //
    // NOTE: it's important these are declared as functions rather than lambdas
    // so that the this keyword refers to the right thing
    //
    eventData.dataTransfer.getData = function (type: string) {
      return overrides.get(type) ?? getDataInner.call(this, type);
    };

    eventData.dataTransfer.setData = function (type: string, data: string) {
      overrides.set(type, data);
      if (!typesInner.includes(type)) {
        overrideTypes.push(type);
      }
    };

    //
    // Replicate behavior of native DataTransfer object
    // see https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
    //
    Object.defineProperty(eventData.dataTransfer, "types", {
      get: function () {
        return [...typesInner, ...overrideTypes];
      },
    });
  }
}
